"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSettingValue = mapSettingValue;
function mapSettingValue(value, type) {
    switch (type) {
        case 'boolean':
            return value === 'true';
        case 'number':
            return parseFloat(value);
        case 'string':
            return value;
        case 'json':
            return JSON.parse(value);
        case 'color':
            return value;
        case 'image':
            return value;
    }
}
